/* np-shopby.js — behaviour for sections/new-shopby.liquid (Shop by Sport / Goal hub). */
(function () {
  "use strict";
  var faqButtons = document.querySelectorAll("[data-acc]");
  faqButtons.forEach(function (btn) {
    btn.setAttribute("aria-expanded", "false");
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      faqButtons.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        var bd = b.parentElement.querySelector(".npfaq-body");
        if (bd) bd.classList.remove("is-open");
      });
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        var body = btn.parentElement.querySelector(".npfaq-body");
        if (body) body.classList.add("is-open");
      }
    });
  });
})();
